var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.length)?_c('div',{staticClass:"chips-container"},_vm._l((_vm.value),function(item,index){return _c('chip',{key:index,class:_vm.chipClass},[_vm._t("default",null,{"item":item,"index":index})],2)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }